const loadScript = (url, callback) => {
    const script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
        if (callback) callback();
    };
};
export default loadScript;